
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 3a1 1 0 011 1 9 9 0 009 9 1 1 0 110 2C6.925 15 2 10.075 2 4a1 1 0 011-1z"></path><path d="M4.5 2c-.891-.073-1.792.937-2 1.5-.319.863.024 1.743.5 2.5.476.757 2 0 3-1L4.5 2z"></path><path d="M11.5 11c-.801.397-1.612 1.91-1.5 2.5.172.904 1.606 1 2.5 1 1 0 1.41-.944 1.75-2.317L11.5 11z"></path>
    </svg>
  </template>
  <script>
    export default {
      name: "IconTelphone",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
